<template>
  <div class="record-wrapper" v-if="isactive">
    <div class="search-box">
      <w-row :gutter="20" class="search-line">
        <w-col :span="16">
          <label for="seachDate1" class="label">时间段</label>
          <vue-datepicker-local format="YYYY-MM-DD" clearable v-model="fromTime"></vue-datepicker-local>~
          <vue-datepicker-local format="YYYY-MM-DD" clearable v-model="toTime"></vue-datepicker-local>
        </w-col>
      </w-row>
      <w-row class="search-line">
        <div class="search-item search-item-1">
          <label class="label">操作</label>
          <w-select v-model="optionVale" id="seachOperate">
            <w-option
              v-for="(i,index) in oprationTypes"
              :value="i.value"
              :label="i.label"
              :key="index"></w-option>
          </w-select>
        </div>
        <div class="search-item">
          <label for="seachDetail">操作详情</label>
          <input class="input__inner" type="text" v-model="detail" id="seachDetail" />
        </div>
        <div class="search-item">
          <label for="seachAcount">操作者账号</label>
          <input class="input__inner" type="text" v-model="acount" id="seachAcount" />
        </div>
        <div class="search-item margin-left-10">
          <w-button type="minor" @click="search">查询</w-button>
        </div>
      </w-row>
    </div>
    <div class="table-box" id="table-box" :class="total > pageSize?'table-box-page':''">
      <simple-table :height="tableHeight - (total > pageSize ? 50 : 0)" :showNoData="dataList.length === 0" no-data-text="暂无工程操作记录">
        <template slot="header">
          <thead class="has-gutter">
            <tr class>
              <th width="110">
                <em
                  class="sort-btn-fixed position-relative"
                  @click="timeSort"
                  data-type="operateTime"
                >
                  时间
                  <i class="sort" :class="timeActive? 'sort-down': 'sort-up'"></i>
                </em>
              </th>
              <th width="70">操作</th>
              <th width="220">操作详情</th>
              <th width="150">类型</th>
              <th width="150">操作者账号</th>
              <th width="70">登录地区</th>
              <th width="150">登录IP</th>
            </tr>
          </thead>
        </template>
        <template slot="body" v-if="dataList.length>0">
          <!--
          <thead class="ui-table_head">
            <tr height="42">
              <th width="110">
                <a class="sort-btn-fixed" data-type="operateTime">
                  时间
                  <i class="sort"></i>
                </a>
              </th>
              <th width="70">操作</th>
              <th width="220">操作详情</th>
              <th width="150">类型</th>
              <th width="150">操作者账号</th>
              <th width="70">登录地区</th>
              <th width="150">登录IP</th>
            </tr>
          </thead>
          -->
          <tbody id="projectContent">
            <tr>
              <td width="110" style="height: 40px;">
                <a class="sort-btn-fixed" data-type="operateTime">
                  时间
                  <i class="sort"></i>
                </a>
              </td>
              <td width="70" style="height: 40px;">操作</td>
              <td width="220" style="height: 40px;">操作详情</td>
              <td width="150" style="height: 40px;">类型</td>
              <td width="150" style="height: 40px;">操作者账号</td>
              <td width="70" style="height: 40px;">登录地区</td>
              <td width="150" style="height: 40px;">登录IP</td>
            </tr>
            <tr v-for="(data, index) in dataList" :key="index">
              <td width="110">{{data.operateTime | formatDate}}</td>
              <td width="70">{{data.description}}</td>
              <td width="220">{{data.detail}}</td>
              <td width="150">{{data.type}}</td>
              <td width="150">{{data.account}}</td>
              <td width="70">{{data.area}}</td>
              <td width="150">{{data.ip}}</td>
            </tr>
          </tbody>
        </template>
        <!--<div slot="body" v-else class="empty-box">-->
          <!--<img src="@/assets/images/default_empty.png" />-->
          <!--<p>暂无工程操作记录</p>-->
        <!--</div>-->
      </simple-table>
    </div>
    <div class="page-box" v-if="total > pageSize">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="currentPage"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[50, 100]"
        :total="total"
      ></w-pagination>
    </div>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import { getCookie } from '@/assets/utils/CommonUtil'
import { SimpleTable } from '@/components/common'
import ManageService from '@/assets/service/manage'
import { formatDate } from '@/assets/utils/Date'
let projectId = getCookie('enterpriseWorkspaceIdValue')
export default {
  name: 'recordsIndex',
  components: {
    SimpleTable,
    VueDatepickerLocal
  },
  data () {
    return {
      tableHeight: 300,
      timeActive: true,
      fromTime: null,
      toTime: null,
      oprationTypes: [{ value: '', label: '全部' }],
      detail: '',
      acount: '',
      optionVale: '',
      total: 0,
      dataList: [],
      pageSize: 50,
      sortType: 0,
      pageNum: 1,
      currentPage: 1
    }
  },
  props: {
    isactive: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isactive: function (a) {
      if (a) {
        this.defaultOpList()
        this.log()
      }
    },
    optionVale: function () {
      this.log()
    }
  },
  filters: {
    formatDate (value) {
      return formatDate(new Date(value), 'yyyy-MM-dd hh:mm:ss')
    }
  },
  methods: {
    log () {
      this.sentLog(100107075, {page: 1, type: this.optionVale || 0})
    },
    // 时间排序
    timeSort () {
      this.timeActive = !this.timeActive
      if (this.timeActive) {
        this.sortType = 0
      } else {
        this.sortType = 1
      }
      this.queryOpList()
    },
    // 页面跳转
    handleCurrentChange (index) {
      this.pageNum = index
      this.queryOpList()
    },
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      this.currentPage = 1
      this.queryOpList()
    },
    // 设置高度
    setTableHeight () {
      // let winH = document.documentElement.clientHeight
      // this.tableHeight = winH - 300
      this.tableHeight = this.getTableHeight('table-box')
    },
    // 检索
    search () {
      this.sentLog(100107073, {page: 1})
      this.dataList = []
      this.pageNum = 1
      this.currentPage = 1
      this.queryOpList()
    },
    // 初始检索数据
    defaultOpList () {
      this.dataList = []
      this.pageSize = 50
      this.pageNum = 1
      this.currentPage = 1
      this.sortType = 0
      this.detail = ''
      this.acount = ''
      this.queryOpList()
    },
    // 请求操作列表
    queryOpList () {
      let params = {
        detail: this.detail ? this.detail : null,
        account: this.acount ? this.acount : null,
        operateType: this.optionVale ? this.optionVale : null,
        sortType: this.sortType,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      if (this.fromTime) {
        params.fromTime = new Date(
          formatDate(new Date(this.fromTime), 'yyyy-MM-dd')
        ).getTime()
      }
      if (this.toTime) {
        params.toTime =
          new Date(formatDate(new Date(this.toTime), 'yyyy-MM-dd')).getTime() +
          86400000
      }
      this.dataList = []
      ManageService.getOperateList(params, projectId)
        .then(res => {
          if (+res.code === 200) {
            this.dataList = res.data.items
            this.total = res.data.totalCount
          } else {
          }
        })
        .catch(e => {})
    },
    // 请求操作类型
    queryOpTypes () {
      let params = {}
      if (this.fromTime) {
        params.fromTime = new Date(
          formatDate(new Date(this.fromTime), 'yyyy-MM-dd')
        ).getTime()
      }
      if (this.toTime) {
        params.toTime =
          new Date(formatDate(new Date(this.toTime), 'yyyy-MM-dd')).getTime() +
          86400000
      }
      ManageService.getOperateTypes(params, projectId)
        .then(res => {
          if (+res.code === 200) {
            let options = [{ value: '', label: '全部' }]
            res.data.map(item => {
              options.push({
                value: item.code,
                label: item.name
              })
            })
            this.oprationTypes = options
          } else {
          }
        })
        .catch(e => {})
    }
  },

  mounted () {
    // 设置表格高度
    setTimeout(() => {
      this.setTableHeight()
    })
    this.resizeHandle.resize(() => {
      this.setTableHeight()
    })
    // 获取请求类型
    this.queryOpTypes()
    this.defaultOpList()
    this.log()
  }
}
</script>
